import { instance } from 'api/core';
import { CallbackObject } from 'api/core/get-page-function';

export const importAsrsServerProductMarkingCsv = async (serverId: string, file: File, callback: CallbackObject<void>) => {
  if (!file) throw new Error('No file provided.');

  const formData = new FormData();
  formData.append('file', file);

  try {
    await instance.post(`/catalog/asrs/${serverId}/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    callback.success();
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
